/**
 * Un rafraichissement periodique qui S'ARRETE quand l'onglet est cache
 * (06/10/2026).
 *
 * Un ecran laisse ouvert derriere une autre fenetre continuait d'interroger
 * le serveur toute la journee, et parfois toute la nuit, pour rien. Ici :
 *   - onglet visible : `fn` tourne toutes les `ms` millisecondes ;
 *   - onglet cache : plus rien ;
 *   - retour sur l'onglet : `fn` tourne TOUT DE SUITE, puis reprend.
 * L'ecran est donc a jour des qu'on le regarde.
 *
 * NE PAS UTILISER POUR UNE ALARME : une alarme doit sonner onglet cache.
 *
 * Rend la fonction d'arret, a appeler au demontage.
 */
export function intervalleVisible(fn: () => void, ms: number): () => void {
  if (typeof document === "undefined") return () => {};

  let minuterie: number | null = null;

  const demarrer = () => {
    if (minuterie === null) minuterie = window.setInterval(fn, ms);
  };
  const arreter = () => {
    if (minuterie !== null) {
      window.clearInterval(minuterie);
      minuterie = null;
    }
  };
  const surChangement = () => {
    if (document.visibilityState === "visible") {
      fn();
      demarrer();
    } else {
      arreter();
    }
  };

  if (document.visibilityState === "visible") demarrer();
  document.addEventListener("visibilitychange", surChangement);

  return () => {
    arreter();
    document.removeEventListener("visibilitychange", surChangement);
  };
}
